import { isNotNativeOnlyAd } from '@utils/ads'
import {
  ValidData,
  MultilineArticle,
  MultilineMegaModule,
  MultilineGridData,
  MultilineDossier,
  GridType,
  NormalContent,
  MultilineWithPagination,
  MultilineWebarchive,
  MultilineHighFive,
} from './types'

const hasValidData = (data: any): data is ValidData =>
  Array.isArray(data?.content) && data.content.length > 0

const hasArticleContent = (data: ValidData): data is MultilineArticle =>
  data.kind.includes('article')

const hasMegaModule = (data: ValidData): data is MultilineMegaModule =>
  data.content.some((item: any) =>
    (item.kind as string[]).includes('mega-module')
  )

const hasPaginatedContent = (
  data: ValidData
): data is MultilineWithPagination =>
  !!(data.content[0] as any)?.content?.[0]?.kind?.includes('section-content')

const hasDossierContent = (data: ValidData): data is MultilineDossier =>
  data.kind.includes('dossier-tabs')

const hasWebarchiveContent = (data: ValidData): data is MultilineWebarchive =>
  data.kind.includes('webarchive')

const isHighFive = (data: ValidData): data is MultilineHighFive =>
  data.id === 'container.high5'

const isMultilineGrid = (data: ValidData): data is MultilineGridData =>
  (Object.values(GridType) as (GridType | undefined)[]).includes(
    data?.options?.grid
  )

const contentWithoutNativeOnlyAds = (content: NormalContent) =>
  content
    .filter((innerWidget) => isNotNativeOnlyAd(innerWidget))
    .reduce((acc, possiblyLayoutItem) => {
      if (!possiblyLayoutItem.content) {
        acc.push(possiblyLayoutItem)
      } else {
        const filteredLayoutItem = {
          ...possiblyLayoutItem,
          content: possiblyLayoutItem.content.filter((item) =>
            isNotNativeOnlyAd(item)
          ),
        }

        if (filteredLayoutItem.content.length > 0) {
          acc.push(filteredLayoutItem)
        }
      }

      return acc
    }, [] as (Record<string, unknown> & { content?: Record<string, unknown>[] })[])

export {
  contentWithoutNativeOnlyAds,
  hasValidData,
  hasMegaModule,
  hasPaginatedContent,
  hasDossierContent,
  hasWebarchiveContent,
  isMultilineGrid,
  hasArticleContent,
  isHighFive,
}
